import { createBlock } from 'factories/block';
import getStore from 'services/getStore';

export const createContinueBtn = ({ ...props }) => {
  const {
    buttonBackgroundColor,
    buttonTextColor,
    buttonShape = 'pill',
    buttonShadow = true,
  } = getStore().getState().theme;

  return createBlock('ContinueButton', 'Continue' as any, {
    props: {
      label: 'Continue',
      background: props.buttonBackground || buttonBackgroundColor,
      color: props.buttonForeground || buttonTextColor,
      buttonShape,
      buttonShadow,
      borderWidth: 1,
      shape: buttonShape,
      font: '',
      location: 'next',
      ...props,
    },
    meta: { subType: 'continue' },
  });
};
